export default {
  talk_to_us: 'Habla con nosotros:',
  send_us_email: 'Envíanos un correo:',
  visit_website: 'Visita nuestro sitio web:',
  join_our_community: '¡Únete a nuestra comunidad para ofertas exclusivas y novedades!',
};
